var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-main",staticStyle:{"padding-left":"59px","padding-right":"59px","text-align":"left"}},[_c('Nav'),_c('Sidebar'),_c('div',{staticClass:"body-container"},[_c('div',{staticClass:"contenedor-body",staticStyle:{"padding":"14px","margin-top":"80px","margin-left":"220px","height":"89vh"}},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }